import { render, staticRenderFns } from "./AppLayoutFooter.vue?vue&type=template&id=24aca310&scoped=true&"
import script from "./AppLayoutFooter.vue?vue&type=script&lang=js&"
export * from "./AppLayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutFooter.vue?vue&type=style&index=0&id=24aca310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aca310",
  null
  
)

export default component.exports